import VerifiedAgencyHexagonal from "../../assets/images/VerifiedAgencyHexagonal.png";
import { Link } from "react-router-dom";

export const VerifiedLogo = () => {
  return (
    <>
      <Link
        to="https://www.designrush.com/agency/profile/haltentech"
        target="_blank"
      >
        <img
          width={100}
          src={VerifiedAgencyHexagonal}
          alt="HaltenTech on DesignRush"
        />
      </Link>
    </>
  );
};
